import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sausage"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M14.4372 4.99927C15.6966 3.73983 17.7386 3.73983 18.998 4.99927C20.2575 6.25871 20.2575 8.30067 18.998 9.56011L9.55815 19C8.29871 20.2594 6.25676 20.2594 4.99732 19C3.73787 17.7405 3.73787 15.6986 4.99731 14.4391L14.4372 4.99927Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 3.00293V4.45M21 4.99941H19.55M5 20.9965L5 19.5494M3 19H4.45M18.9983 4.99941C20.2578 6.25885 20.2578 8.30081 18.9983 9.56025L9.55845 19.0001C8.29901 20.2596 6.25705 20.2596 4.99761 19.0001C3.73817 17.7407 3.73817 15.6987 4.99761 14.4393L14.4375 4.99941C15.6969 3.73997 17.7389 3.73997 18.9983 4.99941Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Sausage = Vue.extend<IconProps>({
  name: 'SausageIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'sausage',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Sausage;
